"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainingWeekOverview = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const TrainingPreview_1 = require("../training-week-item/TrainingPreview");
// TODO: remove overview and component when not needed anymore
exports.TrainingWeekOverview = (0, react_1.memo)(({ onHeaderClick, completed, weekItems, averageRating }) => {
    return ((0, jsx_runtime_1.jsx)(TrainingPreview_1.TrainingPreview, { weekItems: weekItems, average: averageRating, completedTrainings: completed || "", onHeaderClick: onHeaderClick }, void 0));
});
//# sourceMappingURL=index.js.map